export default __webpack_public_path__ + "static/media/cow_ufo.f234ddb9.png";